import 'ui-core/components/modal/js/modal.js';

const modal = UX.modal;
modal.focusCycle = function (e) {
    if (e.target.closest('.bulk-download-modal')) return;
    if (e.shiftKey) modal.revers = true;

    if (e.code === 'Tab') {
        if (!modal.revers) {
            modal.on.tab();
        } else {
            modal.on.tabRevers();
        }
    }
};

modal.on.tabRevers = function () {
    modal.lastItem.off('focusout');
    modal.$close.off('focusout');
};

function handleA11yOpenModal(e) {
    const modals = document.querySelectorAll('.ux-modal-container');
    let oppenedModal;
    modals.forEach(modal => {
        if (modal.firstChild.style.display === 'block') {
            oppenedModal = modal;
            UX.utils.focusCycleInitiator(modal);
        }
    });
    UX.modal.nodesToBeDisabled = UX.utils.disableNodes(oppenedModal);
}

function handleA11yCloseModal() {
    UX.modal.nodesToBeDisabled.forEach(element => {
        element.inert = false;
    });
    document.querySelector('.bulk-download-option')?.focus();
}

modal.accessibility.show = () => {
    $('.content, .footer, .header').attr('aria-hidden', true);
    handleA11yOpenModal();
};

modal.accessibility.hide = () => {
    $('.content, .footer, .header').removeAttr('aria-hidden');
    handleA11yCloseModal();
};
